'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;
var $document = $(document);
var utils = require('./utils.js');
var LeafletOSMMapService = require('./map-services/leaflet-osm-map-service.js');
var Pin = require('./pin.js');
var LocationList = require('./location-list.js');

var Map = function () {
	function Map($container, settings) {
		var _this2 = this;

		_classCallCheck(this, Map);

		var defaults = {
			strings: window.mapsamurai_script_settings.strings,
			map: {
				id: 0,
				type: 'road',
				mode: 'map',
				center: [0, 0],
				tileset: '',

				background: ''
			},
			zoom: {
				enabled: true,
				zoom: 3
			},
			pins: {
				defaultImage: '',
				pins: []
			},
			cluster: {
				enabled: false
			},
			tooltip: {
				background: [255, 255, 255, 1]
			},
			search: {
				centerOnSearch: true,
				radiusUnitName: 'Miles',
				radiusUnit: 'mi',
				radius: 5,
				radiusInMeters: 0,
				regionBias: ''
			},
			filters: {
				centerOnFilter: true
			},
			routes: []
		};
		this.settings = $.extend(true, {}, defaults, settings);
		this.calculateSearchRadiusInMeters();

		this.$container = $container.first();
		if (!this.$container || !this.$container.length) {
			console.log('Could not find map container');
			return;
		}

		this.searchIsSearching = false;
		this.searchLastResult = null;
		this.searchRadiusInMeters = 0;
		this.searchLastClosestPin = null;

		window.MapSamurai.instances.push(this);
		this.$container.data('mapsamurai-lite', this);
		this.$canvas = this.$container.find('.mpfy-map-canvas:first');
		this.$zoomInButton = this.$container.find('.mpfy-zoom-in:first');
		this.$zoomOutButton = this.$container.find('.mpfy-zoom-out:first');
		this.$tagSelect = this.$container.find('.mpfy-tag-select:first');
		this.$searchForm = this.$container.find('.mpfy-search-form:first');
		this.$searchFormInput = this.$searchForm.find('.mpfy-search-input:first');
		this.$searchFormButton = this.$searchForm.find('.mpfy-search-button:first');
		this.$searchFormClearButton = this.$searchForm.find('.mpfy-search-clear:first');
		this.$searchRadiusSelect = this.$container.find('select[name="mpsmr_search_radius"]:first');
		this.$locationList = this.$container.find('.mpfy-mll:first');
		this.$geolocateButton = this.$container.find('.mpfy-geolocate:first');

		this.proprietaryData = JSON.parse(this.$container.attr('data-proprietary'));
		this.pins = [];

		this.mapService = new LeafletOSMMapService(this.$canvas, {
			map: {
				background: this.settings.map.background,
				tileset: this.settings.map.tileset
			},
			zoom: {
				enabled: this.settings.zoom.enabled,
				zoom: this.settings.zoom.zoom
			},
			cluster: {
				enabled: this.settings.cluster.enabled
			}
		});

		if (this.settings.map.mode === 'image') {
			this.mapService.setType('image');
		} else {
			this.mapService.setType(this.settings.map.type);
		}

		this.mapService.setCenter(this.settings.map.center);
		this.mapService.setZoom(this.settings.zoom.zoom);

		this.locationList = this.$locationList.length > 0 ? new LocationList(this.$locationList, this) : null;

		this.addEvents();
		this.addPins().then(function () {
			_this2.addRoutes(); // ← ✅ Insert here to render saved routes
			_this2.$container.trigger('mapsamurai.map.loaded', _this2);
			return Promise.resolve();
		});
	}

	_createClass(Map, [{
		key: 'calculateSearchRadiusInMeters',
		value: function calculateSearchRadiusInMeters() {
			this.settings.search.radiusInMeters = utils.unit2meters(this.settings.search.radius, this.settings.search.radiusUnit);
		}
	}, {
		key: 'addRoutes',
		value: function addRoutes() {
			var _this3 = this;

			if (!this.settings.routes || this.settings.routes.length === 0) return;

			this.settings.routes.forEach(function (route) {
				var latlngs = route.waypoints.map(function (wp) {
					return L.latLng(wp.lat, wp.lng);
				});
				if (!latlngs.length) return;

				if (route.type === 'custom') {
					L.polyline(latlngs, {
						color: route.color || '#3a6fac',
						weight: route.width || 5
					}).addTo(_this3.mapService.map);
				} else if (route.type === 'automatic' && latlngs.length >= 2) {
					var plan = L.Routing.plan(latlngs, {
						createMarker: function createMarker() {
							return null;
						}
					});
					L.Routing.control({
						plan: plan,
						lineOptions: {
							styles: [{ color: route.color || '#3a6fac', weight: route.width || 5 }]
						},
						addWaypoints: false,
						draggableWaypoints: false,
						routeWhileDragging: false,
						show: false
					}).addTo(_this3.mapService.map);
				}
			});
		}
	}, {
		key: 'getProprietaryData',
		value: function getProprietaryData(key) {
			if (typeof this.proprietaryData[key] == 'undefined') {
				return null;
			}
			return this.proprietaryData[key];
		}
	}, {
		key: 'addPins',
		value: function addPins() {
			for (var i = 0; i < this.settings.pins.pins.length; i++) {
				var pinModel = this.settings.pins.pins[i];

				var tooltipClasses = ['mpfy-tooltip-map-' + this.settings.map.id, 'mpfy-tooltip-image-orientation-' + this.settings.tooltip.imageOrientation];
				if (pinModel.thumbnail) {
					tooltipClasses.push('mpfy-tooltip-with-thumbnail');
				}
				var pin = new Pin(pinModel, {
					classes: tooltipClasses.join(' '),
					background: this.settings.tooltip.background,
					content: pinModel.tooltipContent,
					closeBehavior: pinModel.tooltipCloseBehavior,
					animate: pinModel.animateTooltips
				}, {
					hideInitially: !!this.settings.pins.hideInitially
				});
				this.pins.push(pin);
			}
			return this.mapService.addPins(this.pins);
		}
	}, {
		key: 'addEvents',
		value: function addEvents() {
			var _this4 = this;

			var _this = this;

			_this.tagSelectEvent = function () {
				var tagId = $(this).val();
				_this.filterByTag(tagId);
			};

			if (_this.$tagSelect.length > 0) {
				_this.$tagSelect.off('change').on('change', _this.tagSelectEvent);
				_this.$tagSelect.trigger('change');
			}

			$document.one('ready', function () {
				$('body').trigger('mapsamurai.map.created', _this);

				if (_this.$tagSelect.length > 0) {
					_this.$tagSelect.on('change', _this.tagSelectEvent);
				}

				if (_this.$searchRadiusSelect.length > 0) {
					_this.$searchRadiusSelect.on('change', function () {
						_this.settings.search.radius = parseInt($(this).val());
						_this.calculateSearchRadiusInMeters();
					}).trigger('change');
				}
			});

			$(window).on('load resize orientationchange mapsamurai.redraw', function () {
				var controls = _this.$container.find('.mpfy-controls:first');
				var breakingWidth = 650;
				var controlsWidth = controls.width();
				controls.toggleClass('mpfy-controls-mobile', controlsWidth <= breakingWidth);
				_this.$container.toggleClass('mpfy-layout-mobile', controlsWidth <= breakingWidth);
			});

			if ("ontouchstart" in window || navigator.msMaxTouchPoints) {
				this.$container.addClass('mpfy-touch-device');
			}

			this.$searchFormClearButton.click(function (e) {
				e.preventDefault();
				_this.clearSearch();
			});

			this.$searchFormInput.bind('keyup change', function (e) {
				_this.$searchFormClearButton.toggle($(this).val().length > 0);
			});

			this.$zoomInButton.click(function (e) {
				e.preventDefault();
				_this.mapService.setZoom(_this.mapService.getZoom() + 1);
			});

			this.$zoomOutButton.click(function (e) {
				e.preventDefault();
				_this.mapService.setZoom(Math.max(0, _this.mapService.getZoom() - 1));
			});

			this.$container.find('.mpfy-selecter-wrap select').selecter();

			this.$searchForm.submit(function (e) {
				e.preventDefault();
				var recenterOnBlank = typeof e.mapsamurai == 'undefined' || typeof e.mapsamurai.recenterOnBlank == 'undefined' ? true : e.mapsamurai.recenterOnBlank;

				var query = _this.$searchFormInput.val().toLowerCase();
				_this.search(query, recenterOnBlank);
			});

			this.$geolocateButton.on('click', function (e) {
				e.preventDefault();
				_this4.mapService.locate().then(function () {
					_this.$container.trigger('mapsamurai.useMyLocation.ended');
				});
			});
		}
	}, {
		key: 'getPinById',
		value: function getPinById(pinId) {
			for (var i = 0; i < this.pins.length; i++) {
				var pin = this.pins[i];
				if (pin.model.id == pinId) {
					return pin;
				}
			}
			return null;
		}
	}, {
		key: 'getVisiblePins',
		value: function getVisiblePins() {
			return this.pins.filter(function (pin) {
				return pin.isVisible();
			});
		}
	}, {
		key: 'filter',
		value: function filter(visibilityCondition, filterCallback) {
			var baseVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			var _this = this;
			var promises = [];
			for (var i = this.pins.length - 1; i >= 0; i--) {
				var pin = this.pins[i];
				pin.setVisibility(visibilityCondition, filterCallback(pin));
				pin.setVisibility('base', baseVisibility);
				promises.push(this.mapService.updatePinVisibility(pin));
			}
			return Promise.all(promises).then(function () {
				_this.$container.trigger('mapsamurai.pins.visibilityUpdated', visibilityCondition);
			});
		}
	}, {
		key: 'filterByTag',
		value: function filterByTag(tagId) {
			var _this = this;
			tagId = parseInt(tagId);
			_this.$tagSelect.off('change', _this.tagSelectEvent);
			this.$tagSelect.val(tagId).trigger('change');
			_this.$tagSelect.on('change', _this.tagSelectEvent);

			return Promise.resolve().then(function () {
				if (tagId <= 0) {
					return _this.filter('tag', function (pin) {
						return true;
					}, !_this.settings.pins.hideInitially).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}) // always center first
					.then(function () {
						return _this.mapService.setZoom(_this.settings.zoom.zoom);
					}).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}); // center again after zoom to avoid rounding inaccuracies
				}

				return _this.filter('tag', function (pin) {
					return typeof pin.model.tags[tagId.toString()] !== 'undefined';
				}).then(function () {
					if (_this.settings.filters.centerOnFilter) {
						var visiblePins = _this.getVisiblePins();
						return _this.mapService.fitPins(visiblePins);
					}
					return Promise.resolve();
				});
			}).then(function () {
				_this.$container.trigger('mapsamurai.filter.ended', {
					tagId: tagId
				});
			});
		}
	}, {
		key: 'requestSearchResults',
		value: function requestSearchResults(query, recenterOnBlank) {
			var _this = this;
			if (_this.searchIsSearching) {
				return Promise.reject('busy');
			}

			_this.searchLastResult = null;
			if (query.length === 0) {
				return _this.filter('search', function (pin) {
					return true;
				}).then(function () {
					if (recenterOnBlank) {
						return _this.mapService.setCenter(_this.settings.map.center);
					}
					return Promise.resolve();
				});
			}

			if (_this.settings.map.mode === 'image') {
				return _this.filter('search', function (pin) {
					return pin.model.city.indexOf(query) !== -1 || pin.model.city.indexOf(query) !== -1;
				}).then(function () {
					if (_this.getVisiblePins().length === 0) {
						utils.showSearchPopup(_this, _this.settings.strings.no_search_results);
					}
					return Promise.resolve();
				});
			}

			_this.searchIsSearching = true;
			return _this.mapService.geocode(query + ', ' + _this.settings.search.regionBias).then(function (results) {
				if (results.length === 0) {
					utils.showSearchPopup(_this, _this.settings.strings.search_geolocation_failure);
					return Promise.resolve();
				}

				var result = results[0];
				_this.searchLastResult = result;

				var filteredPins = _this.mapService.getPinsWithinRange(result.lat, result.lng, _this.settings.search.radiusInMeters);

				return _this.filter('search', function (pin) {
					return filteredPins.indexOf(pin) !== -1;
				}).then(function () {
					if (_this.getVisiblePins().length === 0) {
						_this.searchLastClosestPin = _this.mapService.getPinClosestTo(result.lat, result.lng);
						utils.showSearchPopup(_this, _this.settings.strings.no_search_results_with_closest);
					}
					return Promise.resolve();
				});
			}).catch(function (error) {
				console.log(error);
			}).then(function () {
				_this.searchIsSearching = false;
				return Promise.resolve();
			});
		}
	}, {
		key: 'search',
		value: function search(query, recenterOnBlank) {
			var _this = this;
			return _this.requestSearchResults(query, recenterOnBlank).then(function () {
				var visiblePins = _this.getVisiblePins();
				if (visiblePins.length > 0 && _this.settings.search.centerOnSearch) {
					return _this.mapService.fitPins(visiblePins);
				}
				return Promise.resolve();
			}).then(function () {
				_this.$container.trigger('mapsamurai.search.ended', {
					'query': query
				});
				return Promise.resolve();
			}).catch(function (error) {
				if (error !== 'busy') {
					return Promise.reject(error);
				}
			});
		}
	}, {
		key: 'clearSearch',
		value: function clearSearch(recenterOnBlank) {
			recenterOnBlank = typeof recenterOnBlank == 'undefined' ? true : recenterOnBlank;
			this.$searchFormInput.val('').trigger('change');
			return this.search('', recenterOnBlank);
		}
	}]);

	return Map;
}();

module.exports = Map;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map.js
// module id = 10
// module chunks = 0